<template>
  <el-dialog
    width="450px"
    :title="item && item.id ? '修改摄像头' : '新增摄像头'"
    :visible="show"
    :close-on-click-modal="false"
    top="0"
    class="flex-center"
    @close="handleClose">
    <el-form :model="info" label-width="100px" label-position="left" ref="form">
      <template v-for="(item, index) in form">
        <el-form-item
          v-if="item.type === 'select'"
          :label="item['label']"
          :key="index"
          :prop="item.key"
          :rules="{ required: true, message: `请选择${item.label}`, trigger: 'blur' }">
          <el-select v-model="info[item['key']]">
            <el-option
              v-for="(option, optionIndedx) in dangerList"
              :key="optionIndedx"
              :label="option.cellName"
              :value="option.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-else
          :label="item['label']"
          :key="index"
          :prop="item.key"
          :rules="{ required: true, message: `请填写${item.label}`, trigger: 'blur' }">
          <el-input v-model="info[item['key']]"></el-input>
        </el-form-item>
      </template>
      <el-form-item label-width="0" class="dialog-btn-box">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { editCamera } from '../../../../api/monitor';
  export default {
    name: "monitor-camera",
    props: {
      show: {
        type: Boolean,
        default: false
      },
      form: {
        type: Array,
        default: () => []
      },
      model: {
        type: String,
        default: ''
      },
      //  设备id
      devId: {
        type: Number,
        default: 0
      },
      item: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      ...mapGetters([
        'dangerList'
      ])
    },
    data() {
      return {
        info: {}
      }
    },
    methods: {
      //  确定
      async handleConfirm() {
        try {
          await this.$refs.form.validate();
          const params = { ...this.info, equipmentId: this.devId ? this.devId : this.info.equipmentId };
          editCamera(params).then(res => {
            this.$emit('success');
            this.handleClose();
          })
          // this.$emit('success', this.info, this.model, this.id);
        } catch (e) {
          return false;
        }
      },
      //  取消
      handleClose() {
        this.$refs.form.resetFields();
        Object.assign(this.$data, this.$options.data());
        this.$emit('close' , this.model);
      }
    },
    watch: {
      item(val) {
        if (val.hasOwnProperty('id')) {
          this.info = { ...val };
          // console.log(val)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog-btn-box {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .el-select {
    width: 100%;
  }
</style>